// modules/house-and-land/Package.js
import React            from 'react';
import { Link }         from 'react-router'
import $                from 'jquery';
// import BackButton       from '../common/BackButton';
import FlyerButton      from '../common/FlyerButton';
import EnquiryButton    from '../common/EnquiryButton';
// import SiteDownloads    from '../common/SiteDownloads';
import PageLoading      from '../PageLoading';
import PackageBed       from '../images/PackageBed';
import PackageBath      from '../images/PackageBath';
import PackageCar       from '../images/PackageCar';
// import TitleBar         from '../common/TitleBar';
// import renderHTML       from 'react-render-html';
import IndividualPackage  from './elements/IndividualPackage';
// import BuilderDetails   from './elements/BuilderDetails';
import BackButton         from '../common/BackButton';

var sources = require('../config.json');

class Package extends React.Component {
	constructor(props) {
		super(props);
		var d = new Date();
		this.package_url = sources.package + '/' +this.props.params.package + "?ts=" + d.getTime();

		this.state = {
			houseandlandpath : sources.houseandlandpath,
			data: {
				thispackage: {},
				builder: {},
				lot: {},
				stage: {},
				packages: []
			},
		};

		this.receivedPackageData    = this.receivedPackageData.bind(this);
		this.processClick           = this.processClick.bind(this);
		this.renderLotPackages      = this.renderLotPackages.bind(this);
		this.renderLotDetails       = this.renderLotDetails.bind(this);
	}

	componentWillMount() {
		window.scrollTo(0, 0);
	}

	changePackage(packageID) {
		var d = new Date();
		let newurl = sources.package + '/' + packageID + "?ts=" + d.getTime();

		// blank things to get page loading spinner
		let newState = Object.assign(this.state, {
			data: {
				thispackage: {},
				builder: {},
				lot: {},
				stage: {},
				packages: []
			},
		});
		this.setState(newState);

		$.ajax({url:newurl,dataType:'json'}).done(this.receivedPackageData);

		window.scrollTo(0, 0);

	}

	componentDidMount() {
		$.ajax({url:this.package_url,dataType:'json'}).done(this.receivedPackageData);
	}

	receivedPackageData(data, status, xhr) {
		let newState = Object.assign(this.state, {
			data: data
		});

		this.setState(newState);

		window.scrollTo(0, 0);
	}

	renderLotPackages(lotpackage) {
		return (
			<IndividualPackage key={lotpackage.p_id} pkdetails={lotpackage} changePackage={this.changePackage.bind(this)} />
		)
	}

	renderLotDetails(lot) {
		console.log(lot);
		let price = lot.l_price_formatted;
		if (lot.l_hotlot > 0) {
			price = lot.l_hotlot_price_formatted;
		}

		return (
			<div key={lot.l_name} className="HLALrow">
				<div className="HLALcell w1">{lot.l_name}</div>
				<div className="HLALcell w1">{lot.l_area}m<sup>2</sup></div>
				<div className="HLALcell nomobile w1">{lot.l_frontage}m</div>
				<div className="HLALcell nomobile w2">{lot.l_stage}</div>
				<div className="HLALcell sm w3">${price}</div>
				<div className="HLALcell bold sm w3">${lot.l_package_price}*</div>
				<div className="HLALcell sm w4">
					<Link to={lot.l_link}>
						View Lot
					</Link>
				</div>
			</div>
		)
	}



	formatNumber(option) {
		var formattedoption;
		if (isNaN(option)) {
			formattedoption = option;
		} else {
			formattedoption = option.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			formattedoption = '$'+ formattedoption;
		}
		return formattedoption;
	}

	processClick(menu,block) {
		document.getElementById('floorplans-menu').classList.remove("active");
		document.getElementById('availablelots-menu').classList.remove("active");
		document.getElementById('similar-menu').classList.remove("active");
		document.getElementById('floorplans').classList.remove("active");
		document.getElementById('availablelots').classList.remove("active");
		document.getElementById('similar').classList.remove("active");
		document.getElementById(menu).classList.add("active");
		document.getElementById(block).classList.add("active");
	}

	render() {

		if (typeof this.state.data.thispackage.p_id !== "undefined") {
			var p_price = this.formatNumber(this.state.data.thispackage.p_price);
			var regText = "Please provide information regarding the house and land package: " + this.state.data.thispackage.p_name + " by " + this.state.data.builder.b_name;
			return (
				<div className="App">
					<div className="outer-site-plans">
						<div className="inner-site-plans">
							<div>
								<div className="HLWhiteBackground">
									<div className="LnButtonContainer">
										<BackButton link={sources.houseandlandpath} bclass="stage-back-button">Search house and land packages</BackButton>
									</div>
									<div className="LnButtonContainer">
										<BackButton link={sources.landforsalepath} bclass="stage-back-button">back to land for sale </BackButton>
									</div>
									<div className="clear-div"></div>
									<div className="HLDetailsListContainer packageDetails">

										<div className="HLdetailsContainer">
											<h1 className="HLpackagename">{this.state.data.thispackage.p_name}</h1>
											<h2 className="HLpackageprice"><span>from</span> {p_price}*</h2>
											<div className="ipackage-detail-container">
												<div className="ipackage-detail bed"><PackageBed/>{this.state.data.thispackage.p_beds}</div>
												<div className="ipackage-detail bath"><PackageBath/>{this.state.data.thispackage.p_baths}</div>
												<div className="ipackage-detail car"><PackageCar/>{this.state.data.thispackage.p_cars}</div>
												<div className="clear-div"/>
											</div>
											<EnquiryButton bclass="hl-enquiry-button" comment={regText}>Enquire</EnquiryButton>
											<FlyerButton key="1" bclass="hl-download-button" link={this.state.data.thispackage.p_pdf}>DOWNLOAD FLYER</FlyerButton>
										</div>
									</div>
									<div className="HLImageAreaContainer">
										<div className="HLipackage-render">
											<img src={this.state.data.thispackage.p_render} alt={this.state.data.thispackage.p_name} />
										</div>
									</div>
									<div className="clear-div"></div>
								</div>
								<div className="clear-div"/>
								<div className="HLadditionalContent">
									<div className="HLContentMenu">
										<div id="floorplans-menu" className="HLContentMenu-item active" onClick={ () => this.processClick('floorplans-menu','floorplans') }><div>FLOOR PLAN</div></div>
										<div id="availablelots-menu" className="HLContentMenu-item" onClick={ () => this.processClick('availablelots-menu','availablelots') }><div>AVAILABLE LOTS</div></div>
										<div id="similar-menu" className="HLContentMenu-item" onClick={ () => this.processClick('similar-menu','similar') }><div>SIMILAR</div></div>
										<div className="HLContentMenu-builder"><img src={this.state.data.builder.b_logo} alt={this.state.data.builder.b_name} /></div>
										<div className="clear-div"></div>
									</div>
									<div className="HLContentContainer">
										<div id="floorplans" className="active">
											<img src={this.state.data.thispackage.p_floorplan} alt={this.state.data.thispackage.p_name} />
										</div>
										<div id="availablelots">
											<div className="HLALtable">
												<div className="HLALrow heading">
													<div className="HLALcell">Lot</div>
													<div className="HLALcell">Size</div>
													<div className="HLALcell nomobile">frontage</div>
													<div className="HLALcell nomobile">release</div>
													<div className="HLALcell">$ lot</div>
													<div className="HLALcell">$ total</div>
													<div className="HLALcell last">&nbsp;</div>
												</div>
												{this.state.data.lot.map(this.renderLotDetails)}
											</div>
										</div>
										<div id="similar">
											{this.state.data.s_packages.map(this.renderLotPackages)}
											<div className="clear-div"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			);

		} else {
			return(
				<PageLoading/>
			);
		}
	}
}

export default Package;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/Package.js
 **/